import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import About from './About';

class Navbar extends Component {
	state = {
		showInfo: false
	}

	toggleInfo = () => {
		this.setState(state => ({
			showInfo: !state.showInfo
		}));
	}

	render() {
		return (
			<>
				<nav className="navbar navbar-dark navbar-colored bg-dark mb-4 shadow fixed-top" >
					<div className="container">
						<Link to="/" className="navbar-brand mx-auto py-1">Testi <span className="text-small"> by Tim Kmecl</span></Link>
						<a href="#" onClick={this.toggleInfo} className="nav-item py-1"><i className="fas fa-info"></i></a>
					</div>
				</nav>
				{this.state.showInfo && <About onClick={this.toggleInfo} />}
			</>
		)
	}

}

export default Navbar
